var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.section != null)?_c('div',{attrs:{"id":"homePage"}},[_c('Header',{attrs:{"menu":_vm.menu,"section":_vm.section,"logoHeight":_vm.logoHeight}}),_c('router-view'),_c('Footer',{attrs:{"section":_vm.section}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }